import CryptoJS from 'crypto-js';
 
export function EncryptDecryptService() {
  // constructor() {
  //   this.key = CryptoJS.enc.Utf8.parse(AppSettings.EncryptionKey);
  //   this.iv = CryptoJS.enc.Utf8.parse(AppSettings.EncryptionIV);
  // }
const key:any= CryptoJS.enc.Utf8.parse('150150mechknow46');
const iv:any=CryptoJS.enc.Utf8.parse('1501504646150150');
  const encrypt=(data:any)=> {
    debugger;
    const encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(data), key, {
      keySize: 128 / 8,
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });
    return encrypted.toString();
  }

  const decrypt=(data:any)=> {
    const decrypted = CryptoJS.AES.decrypt(data, key, {
      keySize: 128 / 8,
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });
    return decrypted.toString(CryptoJS.enc.Utf8);
  }
  return {encrypt,decrypt}
}
